import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { TealiumAnalyticsService } from '@ddt-web/analytics';
import { ERROR_CODES, ERROR_SEVERITY, ErrorDCR } from '@ddt-web/config';

import { PopupDialogAction, PopupDialogActionOptions } from '../models/popup-dialog-object';
import { SimpleErrorObject } from '../models/simple-error-object';
import { AbstractErrorHandlerService } from './abstract-error-handler.service';
import { ErrorHelperService } from './error-helper.service';
import { ErrorPopupService } from './error-popup.service';

@Injectable()
export class AccessDeniedErrorHandlerService extends AbstractErrorHandlerService {

	constructor(
		protected contentService: ContentService,
		protected errorPopupService: ErrorPopupService,
		protected tealiumAnalyticsService: TealiumAnalyticsService,
		protected errorHelperService: ErrorHelperService
	) {
		super(
			contentService,
			errorPopupService,
			tealiumAnalyticsService,
			errorHelperService
		);
	}

	public handleError(error): void {
		if ((error instanceof SimpleErrorObject && error.code === ERROR_CODES.NOT_ALLOWED_DOMAIN)
			|| (error.rejection instanceof SimpleErrorObject && error.rejection.code === ERROR_CODES.NOT_ALLOWED_DOMAIN)) {

			// Tracking
			this.errorSeverity = ERROR_SEVERITY.ERROR;
			this.trackErrorMessage = 'domainaccessnotallowedeerror';
			this.tealiumAnalyticsService.trackError(this.trackErrorMessage, this.errorSeverity);

			// Build error message
			this.errorMessage = this.contentService.get('GENERAL_CONFIG_ERROR', ErrorDCR.GENERAL_CONFIG_ERROR);
			const dialogErrorMessage = this.buildErrorMessage();
			dialogErrorMessage.actions = [
				PopupDialogAction.create({
					description: this.contentService.get('DOMAIN_ACCESS_NOT_ALLOWED_ERROR', ErrorDCR.DOMAIN_ACCESS_NOT_ALLOWED_ERROR),
					label: this.contentService.get('ERROR_RETRY_LABEL', ErrorDCR.ERROR_RETRY_LABEL),
					reload: true
				} as PopupDialogActionOptions)
			];

			console.error('There was an error: DOMAIN_ACCESS_ERROR', error);
			this.errorPopupService.openResponseMessageDialog(dialogErrorMessage, true);

		} else {
			this.nextHandler.handleError(error);
		}
	}
}
